import "core-js/modules/es.array.concat.js";
var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        style: {
            minHeight: "".concat(_setup.height, "px"),
            minWidth: "".concat(_setup.width, "px")
        }
    }, [
        _vm._t("default")
    ], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
